import React, { useRef, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
} from "reactstrap";

import * as ApiManager from "helpers/ApiManager.tsx";
import { useNavigate } from "react-router-dom";

function Login() {
  const usernameRef = useRef();
  const passwordRef = useRef();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e) => {
    if (loading) return;
    e.preventDefault();
    setErrorMsg("");
    setLoading(true);

    const name = usernameRef.current.value;
    const password = passwordRef.current.value;

    try {
      const res = await ApiManager.Login({
        name,
        password,
      });

      if (res && res.data) {
        localStorage.setItem("@token", res.data);
        navigate("/me");
      } else {
        setErrorMsg(res.message);
      }
    } catch (err) {
      setErrorMsg("Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content">
      <Row>
        <Col>
          <Card>
            <CardHeader className="align-items-center">
              <h4 className="card-title flex-grow-1">Player Login</h4>
            </CardHeader>
            <CardBody className="border border-dashed border-end-0 border-start-0">
              <Row>
                <Col
                  lg={{ size: 6, offset: 3 }}
                  md={{ size: 8, offset: 2 }}
                  xs={12}
                >
                  {errorMsg && <Alert color="danger">{errorMsg}</Alert>}
                  <Form onSubmit={handleSubmit}>
                    <FormGroup>
                      <Label for="name" className="text-primary">
                        In-Game Nick
                      </Label>
                      <Input
                        type="text"
                        id="name"
                        placeholder="Enter name"
                        innerRef={usernameRef}
                        required
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label for="password" className="text-primary">
                        Password
                      </Label>
                      <Input
                        type="password"
                        id="password"
                        placeholder="Enter password"
                        innerRef={passwordRef}
                        required
                      />
                    </FormGroup>

                    <Button color="primary" block disabled={loading}>
                      {loading ? "Loading..." : "Login"}
                    </Button>
                  </Form>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Login;
